(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('moldovaYieldCurvesApp')
        .constant('VERSION', "1.0.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
